import { render, staticRenderFns } from "./TebligatSekliPicker.vue?vue&type=template&id=1d97f640"
import script from "./TebligatSekliPicker.vue?vue&type=script&lang=ts"
export * from "./TebligatSekliPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports